/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DelegationStatus } from '../../models/delegation-status';
import { GetDelegationReportResponse } from '../../models/get-delegation-report-response';

export interface GetDelegationReport$Params {

/**
 * the page number.
 */
  page?: number;

/**
 * the size of a page
 */
  size?: number;

/**
 * sort
 */
  sort?: string;
  search?: string;

/**
 * filter delegations based on created at
 */
  startDate?: string;

/**
 * filter delegations based on created at
 */
  endDate?: string;
  delegator?: Array<number>;
  delegate?: Array<number>;
  status?: Array<DelegationStatus>;
}

export function getDelegationReport(http: HttpClient, rootUrl: string, params?: GetDelegationReport$Params, context?: HttpContext): Observable<StrictHttpResponse<GetDelegationReportResponse>> {
  const rb = new RequestBuilder(rootUrl, getDelegationReport.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('size', params.size, {});
    rb.query('sort', params.sort, {});
    rb.query('search', params.search, {});
    rb.query('startDate', params.startDate, {});
    rb.query('endDate', params.endDate, {});
    rb.query('delegator', params.delegator, {});
    rb.query('delegate', params.delegate, {});
    rb.query('status', params.status, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetDelegationReportResponse>;
    })
  );
}

getDelegationReport.PATH = '/api/administration/reports/delegation';
